export default __webpack_public_path__ + "static/media/arrow.87265461.svg";